import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { ITypedItem } from '../types/resourceParts';
import { Request } from './Request';

export interface IGetPrincipalNamesResult extends IGetItemsResult {
  users: ITypedItem[];
}

export class GetPrincipalNamesRequest extends Request<IGetItemsParams, IGetPrincipalNamesResult> {
  constructor(params: IGetItemsParams) {
    super('getPrincipalNames', params);
  }
}
